import React from "react";
import { Box, Grid } from "@mui/material";
import { useAppState } from "Context/StateContext";
import { useTranslation } from "react-i18next";
import { FiCreditCard } from "react-icons/fi";
import { HiOutlineDocumentText, HiOutlineLogout, HiOutlineUser } from "react-icons/hi";
import { useHistory } from "react-router";
import { getBrandCustom } from "Util/getCustomColor";

import { LAST_PAGE, LINKS } from "../../../constants";
import { Routes } from "../../../util/enums";
import { UserBlockProfileMenuProps } from "../types";
import SvgIconUrl from "../../../helpers/SvgIcon/SvgIconUrl";

import {
  ButtonLink,
  CompanyUserAndEmailWrapper,
  Divider,
  GridItemContainer,
  GridItemLink,
  SectionTitle,
  UserProfileEmail,
  UserProfileImage,
  UserProfileMenuHeader,
  UserProfileName,
} from "./styles";

const BACKICON = require("Assets/icons/arrow-back-2.svg");

export const UserBlockProfileMenu = ({
  billingIsAllowed,
  avatarUrl,
  handleCloseProfileMenu,
}: UserBlockProfileMenuProps) => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const { userLogout, currentUser } = useAppState();

  const openUrl = (url: string, external = false) => {
    if (external) {
      window.open(url, "_blank");
    } else {
      history.push(`/app/${url}`);
    }
    handleCloseProfileMenu();
  };

  const logoutUser = () => {
    userLogout();
  };

  return (
    <Grid container direction="column" data-cy="userProfileMenuContainer">
      <Box sx={{ display: "flex", mb: "12px", flexDirection: "column" }}>
        <Box
          sx={{
            color: getBrandCustom("primaryColor", "#0055A4"),
            cursor: "pointer",
            display: "flex",
          }}
          onClick={handleCloseProfileMenu}
        >
          <SvgIconUrl src={BACKICON} size={20} />
        </Box>
      </Box>
      <SectionTitle>{translate("profile")}</SectionTitle>
      <UserProfileMenuHeader item container direction="row">
        <UserProfileImage src={avatarUrl} alt="user profile" />
        <CompanyUserAndEmailWrapper item>
          <UserProfileName>
            {currentUser ? `${translate("hello")} ${currentUser?.name}!` : translate("unknown")}
          </UserProfileName>
          <UserProfileEmail>
            {currentUser ? currentUser?.email : translate("unknown")}
          </UserProfileEmail>
        </CompanyUserAndEmailWrapper>
      </UserProfileMenuHeader>

      <GridItemContainer container direction="column">
        <Divider />

        <GridItemLink isLogout={false} item>
          <ButtonLink
            onClick={() => {
              window.localStorage.setItem(LAST_PAGE, window.location.pathname);
              openUrl(Routes.PROFILE);
            }}
            isLogout={false}
          >
            <HiOutlineUser />
            {translate("userProfile")}
          </ButtonLink>
        </GridItemLink>

        {billingIsAllowed && (
          <GridItemLink isLogout={false} item>
            <ButtonLink onClick={() => openUrl(Routes.BILLING)} isLogout={false}>
              <FiCreditCard />
              {translate("shipeeziBilling")}
            </ButtonLink>
          </GridItemLink>
        )}

        <GridItemLink isLogout={false} item>
          <ButtonLink
            onClick={() => openUrl(LINKS.termsOfUse, true)}
            isLogout={false}
          >
            <HiOutlineDocumentText />
            {translate("termsAndConditions")}
          </ButtonLink>
        </GridItemLink>

        <Divider />

        <GridItemLink isLogout={true} item>
          <ButtonLink onClick={logoutUser} isLogout={true}>
            <HiOutlineLogout />
            {translate("logout")}
          </ButtonLink>
        </GridItemLink>
      </GridItemContainer>
    </Grid>
  );
};
